/*
 * Copyright (c) 2022. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceEditBulkChange
 */
angular.module("diceApp").component("diceEditBulkChange", {
  bindings: {
    evaluations: "<",
    onChange: "&",
    onCancel: "&"
  },
  templateUrl: "es6/evaluations/bulk/edit.bulk.change.html",
  controllerAs: "editBulkChangeController",
  controller: function (Evaluation, message) {
    const editBulkChangeController = this;

    editBulkChangeController.save = function () {
      Evaluation.bulkEdit({
        evaluationIds: _.map(editBulkChangeController.evaluations, "id"),
        startDate: editBulkChangeController.startDate
      }).$promise.then((result) => {
        message.addInfoLabel("Message.Save.Success");
        editBulkChangeController.onChange({ result });
      });
    };
  }
});
